import { type ComponentProps } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

type TypographyTextVariant = "body" | "subtitle" | "kpi-value";

const typographyTextVariants = cva("m-0", {
  variants: {
    variant: {
      body: `
        mt-1 text-(length:--console-type-body)
        leading-(--console-type-body-line-height) font-normal
        text-(--console-type-body-color)
      `,
      subtitle: `
        mb-[18px] text-(length:--console-type-subtitle)
        text-(--console-text-label)
      `,
      "kpi-value": `
        mb-2 text-(length:--console-type-kpi-value) leading-none font-extrabold
        text-(--console-foreground)
      `,
    },
    isActiveKpi: {
      true: "text-(--console-kpi-primary-foreground)",
      false: null,
    },
  },
  defaultVariants: {
    variant: "body",
    isActiveKpi: false,
  },
});

export const TypographyText = ({
  className,
  variant = "body",
  isActiveKpi = false,
  ref,
  ...props
}: ComponentProps<"p"> &
  VariantProps<typeof typographyTextVariants> & {
    variant?: TypographyTextVariant;
    isActiveKpi?: boolean;
  }) => (
  <p
    ref={ref}
    className={cn(
      typographyTextVariants({
        variant,
        isActiveKpi: variant === "kpi-value" ? isActiveKpi : false,
      }),
      className,
    )}
    {...props}
  />
);

export { typographyTextVariants };
